/**
 * NWScriptEventType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file NWScriptEventType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum NWScriptEventType {
  EventSpellCastAt    = 0x02,
  EventConversation   = 0x07,
  EventUserDefined    = 0x0B,
  EventActivateItem   = 0x12,
};